import { render, staticRenderFns } from "./SupervisorDashboard.vue?vue&type=template&id=ee91cfc6&scoped=true&"
import script from "./SupervisorDashboard.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard.vue?vue&type=style&index=0&id=ee91cfc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee91cfc6",
  null
  
)

export default component.exports